import React from 'react';
import { severityColor } from '../../lib/metricBands';

/**
 * "Left and right at a glance" (lib/report/footComparison): each measurement
 * as one row, the left foot's value and grade on the left, the right foot's
 * on the right, and between them what is measured, in what unit, and the
 * normal range — so the two feet are compared, and explained to the patient,
 * at one look.
 */

export const FOOT_COMPARISON_CSS = `
.clinical .glance { margin-top:10px; }
.clinical .glance-head, .clinical .glance-row { display:grid; grid-template-columns:1fr 1.6fr 1fr; align-items:center; text-align:center; }
.clinical .glance-head { font-weight:700; font-size:9pt; color:#0b2434; border-bottom:2px solid #0b2434; padding:6px 0; }
.clinical .glance-row { border-bottom:1px solid #d9e4e7; padding:9px 0; break-inside:avoid; page-break-inside:avoid; }
.clinical .glance-side .v { display:block; font-size:13pt; font-weight:700; color:#0b2434; font-variant-numeric:tabular-nums; }
.clinical .glance-side .g { display:inline-block; margin-top:2px; font-size:8pt; font-weight:700; }
.clinical .glance-side .none { color:#8a989f; font-size:9pt; }
.clinical .glance-mid .n { display:block; font-weight:700; font-size:10pt; color:#0b2434; }
.clinical .glance-mid .u { display:block; font-size:8pt; color:#5b6670; }
.clinical .glance-mid .r { display:block; margin-top:2px; font-size:7.5pt; color:#5b6670; }
@media print {
 .clinical .glance-page { break-after:page; page-break-after:always; }
 .clinical .glance-row { padding:6px 0; }
}
`;

function Side({ s }) {
  if (!s) return <span className="none">—</span>;
  return (
    <>
      <span className="v">{s.value}</span>
      {s.grade && <span className="g" style={s.severity ? { color: severityColor(s.severity) } : undefined}>{s.grade}</span>}
    </>
  );
}

export function FootComparison({ rows }) {
  if (!rows.length) return null;
  return (
    <div className="glance" data-testid="foot-comparison">
      <div className="glance-head"><span>Left foot</span><span>Measurement</span><span>Right foot</span></div>
      {rows.map(r => (
        <div className="glance-row" key={r.id} data-testid={`glance-${r.id}`}>
          <div className="glance-side"><Side s={r.left} /></div>
          <div className="glance-mid">
            <span className="n">{r.name}</span>
            <span className="u">({r.unit})</span>
            {r.reference && <span className="r">{r.reference}</span>}
          </div>
          <div className="glance-side"><Side s={r.right} /></div>
        </div>
      ))}
    </div>
  );
}
